import { Component } from '@angular/core';
import {AuthService} from './shared/services/auth/auth.service';
import {Router} from '@angular/router';
import {Actions, ofActionDispatched} from '@ngxs/store';
import {Logout} from './modules/login/state/login.actions';
import {AnimationOptions} from 'ngx-lottie';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  lottieOptions: AnimationOptions = {
    path: '/assets/lottie/error.json'
  };

  constructor(private router: Router,
              private actions: Actions,
              public authService: AuthService) {
    this.actions.pipe(ofActionDispatched(Logout)).subscribe(() => {
      this.router.navigateByUrl('/login');
    });
  }
  title = 'frontend-admintool';
}
